import serviceUtils from '../../utils'

/**
* 新版发查一体接口
* http://10.177.40.105:13789/project/52/interface/api/682
*/
export function newSuperSendWithRecord(args) {
    args.activityId = window._eaid

    return new Promise((resolve, reject) => {
        const response = window.AllBridge.request({
            $nodeId: args.$nodeId,
            $nodeLabel: args.$nodeLabel,
            $nodeType: args.$nodeType,
            $nodeVersion: args.$nodeVersion,
            $nodeCalcSuccessExpression: args.$nodeCalcSuccessExpression,
            url: '/actgateway/marketcenter.java.active.template.website/api/v2/lottery/newSuperSendWithRecord',
            method: 'post',
            withCredentials: true,
            data: args
        }).then(response => {
            let result = response.data && response.data.result
            if (!response.data) {
                reject({ code: 1000, message: '服务端返回结果为空' })
                return
            }
            if (!response.data.success) {
                reject({ code: response.data.code, message: response.data.msg })
                return
            }

            if (!result) {
                reject({ code: 1000, message: '服务端返回结果为空' })
            } else {
                return resolve(response.data)
            }
        }).catch(error => {
            error.code = '5000'
            reject(error)
        })
    })
}
